// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SunsetFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M81.335 66.227H14.664a2 2 0 0 0 0 4h66.671a2 2 0 0 0 0-4Zm-7.324 12.176H21.985a2 2 0 0 0 0 4h52.026a2 2 0 1 0 0-4ZM87.5 56.05a2 2 0 0 1-2 2h-75a2 2 0 1 1 0-4h13.004C23.78 40.777 34.662 30.063 48 30.063c13.339 0 24.223 10.714 24.499 23.987H85.5a2 2 0 0 1 2 2ZM48 23.708a2 2 0 0 0 2-2V11.597a2 2 0 0 0-4 0v10.111a2 2 0 0 0 2 2Zm-24.648 9.038c.39.39.902.585 1.414.585a2 2 0 0 0 1.414-3.414l-7.151-7.148a2 2 0 1 0-2.828 2.829l7.151 7.148Zm46.467 0a2 2 0 0 1 0-2.829l7.151-7.148a2 2 0 1 1 2.828 2.829l-7.151 7.148c-.39.39-.902.585-1.414.585a1.997 1.997 0 0 1-1.414-.585Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default SunsetFilled;
